// shown in both modes; with WMS off the sync and resend actions are disabled (see the components)
const routes = [
	{
		path: "/system/wms",
		name: "wms",
		meta: {
			reqAuth: true,
			gate: "view_system",
		},
		component: () => import("../views/Wms.vue"),
	},
	{
		path: "/system/wms/logs",
		name: "wms-logs",
		meta: {
			reqAuth: true,
			gate: "view_system",
		},
		component: () => import("../views/WmsLogs.vue"),
	},
];

export default routes;
